import {
  CContainer,
  CModal,
  CModalBody,
  CModalHeader,
  CModalTitle,
} from "@coreui/react";
import { useEffect, useState } from "react";
import Errors from "../../models/errors";
import Document, { newDocument } from "../../models/document";
import DocumentForm from "./DocumentForm";

interface DocumentUpdateModalProps {
  show: boolean;
  document?: Document;
  onCancel: () => void | Promise<void>;
  onSuccess: () => void | Promise<void>;
}

const DocumentUpdateModal: React.FC<DocumentUpdateModalProps> = ({
  show,
  document,
  onCancel,
  onSuccess,
}) => {
  const [initialErrors, setInitialErrors] = useState<Errors>({});
  const [initialDocument, setInitialDocument] = useState<Document>(
    document ? document : newDocument()
  );

  const modalTitle = document
    ? `Editar Documento: ${document.name}`
    : `Crear Documento Nuevo`;

  const onClose = () => {
    setInitialErrors({});
    setInitialDocument(newDocument());
    onCancel();
  };
  useEffect(() => {
    setInitialDocument(document ? document : newDocument());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [document]);

  return (
    <CModal show={show} onClose={onClose} size="xl">
      <CModalHeader closeButton>
        <CModalTitle>{modalTitle}</CModalTitle>
      </CModalHeader>
      <CModalBody>
        <CContainer fluid>
          <DocumentForm
            initialDocument={initialDocument}
            initialErrors={initialErrors}
            onCancel={onCancel}
            onSuccess={onSuccess}
          />
        </CContainer>
      </CModalBody>
    </CModal>
  );
};

export default DocumentUpdateModal;
